var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 3.33398H6C6.368 3.33398 6.66667 3.61265 6.66667 3.95598V12.0453C6.66667 12.3887 6.368 12.6673 6 12.6673H4.66667C4.29867 12.6673 4 12.3887 4 12.0453V3.95598C4 3.61265 4.29867 3.33398 4.66667 3.33398ZM10 3.33398H11.3333C11.7013 3.33398 12 3.61265 12 3.95598V12.0453C12 12.3887 11.7013 12.6673 11.3333 12.6673H10C9.632 12.6673 9.33333 12.3887 9.33333 12.0453V3.95598C9.33333 3.61265 9.632 3.33398 10 3.33398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseFilled);
export default __webpack_public_path__ + "static/media/pause-filled.7a03d55301989fbee52497e6bf394089.svg";
export { ForwardRef as ReactComponent };